export function initSolrCategorySearch() {
    const customCategoriesSearchElement = document.querySelector('[data-custom-search-url]');

    if (null === customCategoriesSearchElement) {
        return;
    }
    const searchUrl = customCategoriesSearchElement.dataset?.customSearchUrl;

    if (!searchUrl) {
        return;
    }

    customCategoriesSearchElement.addEventListener('toujou-solr-search-before-search', function (e) {
        const urlObject = new URL(searchUrl, document.location);
        e.detail.searchParams.forEach((value, name) => {
            urlObject.searchParams.append(name.replace(/\[\d+]/gm, '[]'), value);
        });
        document.location.href = `${urlObject.toString()}`;
        e.preventDefault();
    });

    const searchForm = customCategoriesSearchElement.querySelector('form');

    if (!searchForm) {
        return;
    }

    searchForm.addEventListener('submit', (e) => {
        e.preventDefault();

        const urlObject = new URL(searchUrl, document.location);
        const formData = new FormData(e.target);
        const searchParams = new URLSearchParams(formData);
        searchParams.forEach((value, name) => {
            urlObject.searchParams.append(name.replace(/\[\d+]/gm, '[]'), value);
        });
        document.location.href = `${urlObject.toString()}`;
    });
}
